import { InformationOutline30Icon } from "@vygruppen/spor-icon-react";
import { useTranslation } from "react-i18next";
import { Text, VStack } from "shared/components/Spor";
import { useTheme } from "styled-components";

type NoEventDataMessageProps = {
  mt?: string;
  text?: string;
  showIcon?: boolean;
};

export const NoEventDataMessage = ({
  mt,
  text,
  showIcon = true,
}: NoEventDataMessageProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <VStack
      backgroundColor={theme.colorBackgroundMain}
      flexGrow={1}
      justifyContent="center"
      gap="2"
      mt={mt}
      width="100%"
      borderRadius="6px"
      border={`1px solid ${theme.colorOutlineSecondary}`}
    >
      {showIcon && <InformationOutline30Icon />}
      <Text textAlign="center" maxWidth="700px">
        {text ?? t("Oisann! Her mangler det data for hendelsen.")}
      </Text>
    </VStack>
  );
};
